import { FC } from 'react';
import { ComponentFields } from '@sitecore-jss/sitecore-jss/types/layout/models';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

import { icon_qsg } from '@gn-audio/icons';
import { JabraIcon } from '@gn-audio/jss-components';
import { DictionaryFields, ImageFields, mapSharedPropertiesToFields } from '@gn-audio/jss-core';

import ImageTile from 'common/components/ImageTile/ImageTile';

export type Config = {
  fields: {
    data: {
      item: {
        id: string;
        title: Field<string> & DictionaryFields[''];
        bottomText: Field<string> & DictionaryFields[''];
        imageTiles: {
          results: ImageTile[];
        };
      };
    };
  };
};

export type ImageTile = {
  id: string;
  image: ImageFields[''];
  title: Field<string> & DictionaryFields[''];
};

export type BoxContentProps = Config;

const BoxContent: FC<BoxContentProps & Config> = ({ fields }) => {
  if (!fields.data.item) {
    return null;
  }

  const config = mapSharedPropertiesToFields<{ title: Field<string>; bottomText: Field<string> }>(
    fields.data.item as unknown as ComponentFields
  );

  const {
    data: {
      item: {
        imageTiles: { results: imageTiles },
      },
    },
  } = fields;

  const useFourCols = imageTiles.length >= 4;
  const gridClasses = useFourCols
    ? 'lg:grid-cols-4'
    : 'lg:grid-cols-[repeat(auto-fit,minmax(12.5rem,25%))]';

  return (
    <div className="container">
      <h2 className="mb-6 text-center text-4xl font-bold leading-[3.25rem] xl:mb-16">
        {config.title.value}
      </h2>
      <div
        className={classNames(
          'grid grid-cols-1 justify-center justify-items-center gap-4 sm:grid-cols-2 md:grid-cols-2',
          gridClasses
        )}
      >
        {imageTiles.map((imageTile) => {
          const item = mapSharedPropertiesToFields<ImageTile>(
            imageTile as unknown as ComponentFields
          );

          return (
            <ImageTile
              key={imageTile.id}
              title={item.title.value}
              image={{
                alt: imageTile.image.jsonValue.value.alt,
                src: imageTile.image.jsonValue.value.src,
              }}
            />
          );
        })}
      </div>
      {config.bottomText?.value && (
        <div className="mt-4 flex items-center justify-center xl:mt-16">
          <JabraIcon Icon={icon_qsg} className="mr-2 size-10" />
          <span>+ {config.bottomText.value}</span>
        </div>
      )}
    </div>
  );
};

export default BoxContent;
